import { render, staticRenderFns } from "./newsfeed.vue?vue&type=template&id=2be5ef98&"
import script from "./newsfeed.vue?vue&type=script&lang=ts&"
export * from "./newsfeed.vue?vue&type=script&lang=ts&"
import style0 from "./newsfeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports